import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import {
  STEP_STATE_COMPLETED,
  STEP_STATE_COMPLETED_WITH_ERRORS,
  STEP_STATE_DISABLED,
  STEP_STATE_OPEN,
} from 'lib/stepper'
import { ASSIGNMENT_STATE_POST } from 'lib/assignmentStates'
import { AGENDA_STATE_PLANNED } from 'lib/agenda'

import {
  ASSIGNMENT_STEPS_LIST,
  ASSIGNMENT_STEP_CAP_MANAGEMENT,
  ASSIGNMENT_STEP_PUBLICATION,
  handleDeltaErrors,
} from './assignmentLib'

const useAssignmentSteps = () => {
  const { t } = useTranslation()

  const handleStepValidation = useCallback((step, session, partners, cars) => {
    if (step === ASSIGNMENT_STEP_PUBLICATION) {
      return (
        session.agenda.assignment.state !== AGENDA_STATE_PLANNED &&
        !!session.confirmationAcceptedAt &&
        !session.assignmentStartedAt &&
        !session.assignmentEndedAt
      )
    }

    if (step === ASSIGNMENT_STEP_CAP_MANAGEMENT) {
      return (
        handleDeltaErrors(cars, partners, ASSIGNMENT_STATE_POST, session) <= 0
      )
    }

    return true
  }, [])

  const getStepsWithState = useCallback(
    (session, partners, cars) => {
      if (!Object.keys(session).length) return {}
      return ASSIGNMENT_STEPS_LIST.map((step) => {
        const result = {
          step,
          label: t(`assignment.${step}.step`),
          state: STEP_STATE_OPEN,
        }
        if (
          step !== ASSIGNMENT_STEP_PUBLICATION &&
          !session.assignmentStartedAt
        ) {
          result.state = STEP_STATE_DISABLED
          return result
        }
        if (
          !!session.confirmationAcceptedAt &&
          !!session.assignmentStartedAt &&
          (step !== ASSIGNMENT_STEP_PUBLICATION
            ? !!session.assignmentEndedAt
            : true)
        ) {
          result.state = STEP_STATE_COMPLETED
          return result
        }

        if (
          !handleStepValidation(step, session, partners, cars) &&
          step === ASSIGNMENT_STEP_CAP_MANAGEMENT
        ) {
          result.state = STEP_STATE_COMPLETED_WITH_ERRORS
          return result
        }
        return result
      })
    },
    [handleStepValidation, t]
  )

  return {
    handleStepValidation,
    getStepsWithState,
  }
}

export default useAssignmentSteps
